module.exports = __webpack_public_path__ + "static/media/cargdor.e3af3718.gif";